// Engagement Category UI Constants

import { useAppsStore } from "@/pinia/appsStore";

export const ENGAGEMENT_CATEGORIES = {
  acquisition: { value: "acquisition", label: "Acquisition" },
  retention: { value: "retention", label: "Retention" },
  win_back: { value: "win_back", label: "Win Back" },
  upgrade: { value: "upgrade", label: "Upgrade" },
  engagement: { value: "engagement", label: "Engagement" },
};

export const ENGAGEMENT_SUBCATEGORIES = {
  voluntary: { value: "voluntary", label: "Voluntary Churn" },
  involuntary: { value: "involuntary", label: "Involuntary Churn" },
};

// Local fallback registry mirroring the server hash shape ({ [category]: [descriptors] }).
// The server payload overrides this; add an entry here only for a category whose
// subcategories must exist before the payload provides them.
export const ENGAGEMENT_SUBCATEGORIES_BY_CATEGORY = {
  retention: Object.values(ENGAGEMENT_SUBCATEGORIES),
};

export const ENGAGEMENT_CATEGORY_DESCRIPTION = {
  prompt:
    "Categorizing your prompt allows us to measure its specific success rate. This ensures your revenue reports accurately reflect how well your Acquisition, Retention, or Upgrade strategies are performing.",
  guide:
    "Categorizing your guide allows us to measure its specific success rate. This ensures your revenue reports accurately reflect how well your Acquisition, Retention, or Upgrade strategies are performing. All prompts in this guide will inherit this category.",
};

export const getCategoryLabel = value => {
  const labels = {
    [ENGAGEMENT_CATEGORIES.acquisition.value]: ENGAGEMENT_CATEGORIES.acquisition.label,
    [ENGAGEMENT_CATEGORIES.retention.value]: ENGAGEMENT_CATEGORIES.retention.label,
    [ENGAGEMENT_CATEGORIES.win_back.value]: ENGAGEMENT_CATEGORIES.win_back.label,
    [ENGAGEMENT_CATEGORIES.upgrade.value]: ENGAGEMENT_CATEGORIES.upgrade.label,
    [ENGAGEMENT_CATEGORIES.engagement.value]: ENGAGEMENT_CATEGORIES.engagement.label,
  };
  return labels[value] || value;
};

export const getCategoryColor = value => {
  const colors = {
    [ENGAGEMENT_CATEGORIES.acquisition.value]: "#E8F5E9", // Light green
    [ENGAGEMENT_CATEGORIES.retention.value]: "#E3F2FD", // Light blue
    [ENGAGEMENT_CATEGORIES.win_back.value]: "#FFF3E0", // Light orange
    [ENGAGEMENT_CATEGORIES.upgrade.value]: "#F3E5F5", // Light purple
    [ENGAGEMENT_CATEGORIES.engagement.value]: "#E0F7FA", // Light cyan
  };
  return colors[value] || "#F5F5F5"; // Light gray
};

export const getSubcategoryLabel = value =>
  Object.values(useAppsStore().app?.engagement_subcategories || {})
    .flat()
    .find(s => s?.value === value)?.label ??
  Object.values(ENGAGEMENT_SUBCATEGORIES_BY_CATEGORY)
    .flat()
    .find(s => s?.value === value)?.label ??
  value;

export const ENGAGEMENT_SUBCATEGORY_COLOR = "#F5F5F5"; // Light gray — no per-value styling today
